<template>
  <sidebar-layout :sidebarItems="sidebarItems">
    <template v-slot:mainContent>
      <router-view></router-view>
    </template>
  </sidebar-layout>
</template>

<script>
import SidebarLayout from "@/modules/commonModule/layouts/SidebarLayout";
export default {
  name: "PortsMainView",
  components: { SidebarLayout },
  data() {
    return {
      sidebarItems: [
        {
          text: "Dashboard",
          link: "/port/dashboard",
          icon: "view-dashboard"
        },
        {
          text: "Incoming Shipments",
          link: "/port/incoming-shipments",
          icon: "note-plus"
        },
        {
          text: "Berth Shipments",
          link: "/port/berth-shipments",
          icon: "stamper"
        },
        { 
          text: "Expected Departures", 
          link: "/port/expected-departures", 
          icon: "view-list" },
        {
          text: "Completed Shipments",
          link: "/port/completed-shipments",
          icon: "check"
        },
        {
          text: "Port Shipment History",
          link: "/port/port-history",
          icon: "view-list"
        },
        //  {
        //   text: "Shipping Details",
        //   link: "/port/shipping-details",
        //   icon: "view-list"
        // },
        {
          text: "Profile Settings",
          link: "/port/profile-settings",
          icon: "settings"
        }
        
      ]
    };
  }
};
</script>
